import React from 'react';

export interface GameStartScreenProps {
  playerName: string | null;
  isSinglePlay: boolean;
  totalAttempts: number;
  successfulAttempts: number;
  onStart: () => void;
  isAutoMode: boolean;
  level?: number;
  themeName?: string;
  themeDescription?: string;
}

const GameStartScreen: React.FC<GameStartScreenProps> = ({
  playerName,
  isSinglePlay,
  totalAttempts,
  successfulAttempts,
  onStart,
  isAutoMode,
  level,
  themeName,
  themeDescription
}) => {
  return (
    <div style={{ 
      position: 'absolute', 
      inset: 0, 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      color: '#FFC107', 
      touchAction: 'none' 
    }}>
      <h1 style={{ margin: 20 }}>
        {isAutoMode 
          ? level 
            ? `Level ${level}`
            : 'Auto Mode'
          : playerName 
            ? `${playerName}!`
            : 'Welcome!'}
        {themeName && (
          <span style={{ display: 'block', fontSize: '1.2em', color: '#E91E63', marginTop: 8 }}>{themeName}</span>
        )}
      </h1>
      {themeDescription && (
        <div style={{
          marginBottom: 18,
          color: '#fff',
          background: 'rgba(233,30,99,0.12)',
          borderRadius: 8,
          padding: '10px 18px',
          fontSize: '1.1em',
          fontWeight: 500,
          maxWidth: 400,
          textAlign: 'center',
          boxShadow: '0 2px 8px rgba(233,30,99,0.08)'
        }}>
          {themeDescription}
        </div>
      )}
      
      {!isAutoMode && !isSinglePlay && (
        <>
          <div className="stats">
            <p>Total Attempts: {totalAttempts}</p>
            <p>Successful Attempts: {successfulAttempts}</p>
            {totalAttempts > 0 && (
              <p>Success Rate: {((successfulAttempts / totalAttempts) * 100).toFixed(1)}%</p>
            )}
          </div>
          {(totalAttempts === 0) && <h3 style={{ marginBottom: 20 }}>
            You're the first brave soul to challenge the bee! 🛸✨
          </h3>}
        </>
      )}

      {!isAutoMode && isSinglePlay && <h3 style={{ margin: 10, textAlign: 'center' }}> 
        ✨ It's <span style={{ color: '#E91E63', fontWeight: 'bold' }}>Single time </span> play.. They sent some <span style={{ color: '#E91E63', fontWeight: 'bold' }}> secret message </span> ✨
        <br/><span style={{ color: '#E91E63', fontWeight: 'bold' }}>Win to view</span> or the message is <span style={{ color: '#E91E63', fontWeight: 'bold' }}>gone forever</span>..
      </h3>}

      {!isAutoMode && <h3 style={{ margin: 20 }}>You've got 5 taps to kill 🛸! 🎯</h3>}

      <button 
        onClick={onStart}
        style={{
          margin: '5px',
          padding: '15px 40px',
          fontSize: '1.5rem',
          backgroundColor: '#FFC107',
          border: 'none',
          borderRadius: '30px',
          cursor: 'pointer',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          transition: 'transform 0.2s, box-shadow 0.2s',
          WebkitTapHighlightColor: 'transparent',
          touchAction: 'manipulation',
          minWidth: '200px',
          minHeight: '60px'
        }}
      >
        {isAutoMode ? 'Start Level' : 'Start Game'}
      </button>
    </div>
  );
};

export default GameStartScreen; 